import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {isValidElementType} from 'react-is';
import {Route, withRouter} from 'react-router-dom';
import {compose} from '@republic/foundation/lang/function';
import {isFunction} from '@republic/foundation/lang/is';
import {createComponent} from '@republic/react-foundation';
import LazySwitch from './LazySwitch';

export default (
    compose(
        withRouter,
        LazySwitch.context.with('lazy'))(
        createComponent(
            'LazyRoute',
            {
                propTypes: {
                    // Support a subset of react-router's API
                    component: (props, name) => {
                        if (props[name] && !isValidElementType(props[name])) {
                            return new Error(
                                'Invalid prop \'component\' supplied to \'LazyRoute\': ' +
                                'the prop is not a valid React component');
                        }
                    },
                    path: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.arrayOf(PropTypes.string)
                    ]),
                    exact: PropTypes.bool,
                    strict: PropTypes.bool,
                    sensitive: PropTypes.bool,
                    lazy: PropTypes.shape(LazySwitch.context.types).isRequired
                }
            },
            class LazyRoute extends Component {
                constructor(props) {
                    super(props);
                    this.state = {
                        match: null,
                        displayed: false
                    };
                    this.mounted = false;
                    this.cancel = null;
                }

                componentDidMount() {
                    this.mounted = true;
                    this.cancel = (
                        this.props.lazy.register(
                            () => this.props,
                            () => (
                                isFunction(
                                    this.props.component.lazy) ?
                                        this.props.component.lazy() :
                                        null),
                            match => {
                                if (this.mounted) {
                                    this.setState({match});
                                }
                            }));
                }

                componentWillUnmount() {
                    const cancel = this.cancel;

                    this.mounted = false;
                    if (cancel) {
                        cancel();
                        this.cancel = null;
                    }
                }

                render() {
                    const {match} = this.state;

                    if (match) {
                        const {component, location, history} = this.props;

                        return (
                            <Route
                                location={location}
                                history={history}
                                computedMatch={match}
                                component={component} />);
                    } else {
                        return null;
                    }
                }
            })));
